import { FormInstance } from 'antd';
import { createContext } from 'react';
import FormModel from '../models/FormModel';

// Step 1: Create the context
const FormContext = createContext(null);

export class FormManager {
  private forms: Map<string, FormInstance> = new Map();

  private formModels = new Map<string, FormModel>();

  addForm(form: FormInstance, name: string) {
    this.forms.set(name, form);
    this.formModels.set(name, new FormModel(name));
  }

  removeForm(formName: string) {
    this.forms.delete(formName);
    this.formModels.delete(formName);
  }

  async validateAllForms(): Promise<false | Map<string, any>> {
    let formsData = new Map<string, any>();

    for (const [key, form] of this.forms) {
      try {
        let _formData = await form.validateFields();
        formsData.set(key, _formData);
      } catch (error) {
        console.error('Error validating form', error);
        return false;
      }
    }

    return formsData;
  }

  getAllFormValues() {
    let result: any = {};

    for (const [key, form] of this.forms) {
      result[key] = form.getFieldsValue();
    }

    return result;
  }

  getForm(name: string) {
    return this.forms.get(name);
  }

  getFormModel(name: string) {
    return this.formModels.get(name);
  }
}

const formManager = new FormManager();

export function FormManagerProvider({ children }) {
  return (
    <FormContext.Provider value={formManager}>{children}</FormContext.Provider>
  );
}

export default FormContext;
